<template>
  <div data-sb-regression="sb-filters-drawer">
    <sb-drawer
      v-model:active="active"
      version="next"
      close-variation="x"
      side="right"
      :container-class="$style.filters"
    >
      <SbFilterWrapper
        version="next"
        :filters="filterDefinitions"
        :values="pendingFilters"
        data-sb-automation="filter-selection-filter-wrapper"
        @filters-updated="updatePending"
      />
      <template #drawer-header>
        <h3>{{ $t('sbFilterBar.filterOptions.header') }}</h3>
      </template>
      <template #drawer-footer>
        <div :class="$style.footer">
          <sb-button
            variation="minimal"
            version="next"
            :disabled="isResetDisabled"
            data-sb-automation="filter-selection-reset-columns"
            @click="resetFilters"
          >
            {{ $t('sbFilterBar.filterOptions.resetFilters') }}
          </sb-button>
          <sb-button
            variation="minimal"
            version="next"
            data-sb-automation="filter-selection-close"
            @click="close"
          >
            {{ $t('sbFilterBar.filterOptions.close') }}
          </sb-button>
        </div>

        <sb-button
          version="next"
          data-sb-automation="filter-selection-update-columns"
          :disabled="isSaveDisabled"
          @click="save"
        >
          {{ $t('sbFilterBar.filterOptions.updateFilters') }}
        </sb-button>
      </template>
    </sb-drawer>
  </div>
</template>

<script setup>
import { defineModel, defineEmits, defineProps, computed } from 'vue';

import SbDrawer from '@src/components/Drawer/SbDrawer.vue';
import SbButton from '@src/components/Button/SbButton.vue';
import SbFilterWrapper from '@src/components/Filter/SbFilterWrapper.vue';
import { useFilterDrawer } from '@src/components/Filter/composables/useFilterDrawer';

const active = defineModel('active');
const appliedFilters = defineModel('appliedFilters');

const props = defineProps({
  filterDefinitions: {
    type: Array,
    default: () => [],
  },
});
const filters = computed(() => props.filterDefinitions);

const {
  updatePending,
  isSaveDisabled,
  isResetDisabled,
  save,
  resetFilters,
  pendingFilters,
} = useFilterDrawer(appliedFilters, filters, active);

function close() {
  active.value = false;
  resetFilters();
}
</script>

<style lang="scss" module>
@use '@src/components/Filter/next/styles/filtersDrawer.module.scss';
</style>
